import { RootState } from "@/infrastructure/rootState";

// Setup:
export const setup = ({ backtest }: RootState) => backtest.setup;
export const purchaseSize = ({ backtest }: RootState) => backtest.setup.purchase.size;
export const purchaseType = ({ backtest }: RootState) => backtest.setup.purchase.type;
export const minCommission = ({ backtest }: RootState) => backtest.setup.commission.min;
export const commissionPct = ({ backtest }: RootState) => backtest.setup.commission.pct;
export const cash = ({ backtest }: RootState) => backtest.setup.cash;
export const ticker = ({ backtest }: RootState) => backtest.setup.ticker;
export const stock_peer = ({ backtest }: RootState) => backtest.setup.stock_peer;
export const index_peer = ({ backtest }: RootState) => backtest.setup.index_peer;
export const region = ({ backtest }: RootState) => backtest.setup.region;
export const startDate = ({ backtest }: RootState) => backtest.setup.period.start;
export const endDate = ({ backtest }: RootState) => backtest.setup.period.end;
export const strategy = (isBuy: boolean) => ({ backtest }: RootState) =>
  backtest.setup.strategy[isBuy ? "buy" : "sell"];
export const modelSetup = ({ backtest }: RootState) => backtest.setup.modelSetup;
